<div id="modal" #fade class="modal inmodal fade" [style]="getZIndex()" aria-hidden="true" [ngClass]="{ 'in': opened }" [ngStyle]="{ 'display': opened ? 'block' : ''}" (click)="handleClick($event, params, disabled)">
    <div class="modal-dialog" [ngClass]="params.size ? 'modal-' + params.size : ''">
        <div class="modal-content">
            <div class="modal-header">
                <button data-dismiss="modal" class="close" type="button" (click)="!disabled && close(params.closeButton.action)">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">Close</span>
                </button>
                <h4 *ngIf="params.title" class="modal-title">{{params.title}}</h4>
                <h4 *ngIf="params.titleKey" class="modal-title" [i18n]="[{target: 'innerHTML', key: params.titleKey, params: params.titleParam}]"></h4>
                <small class="font-bold" *ngIf="params.subTitle">{{params.subTitle}}</small>
                <small class="font-bold" *ngIf="params.subTitleKey" [i18n]="params.subTitleKey"></small>
            </div>
            <div class="modal-body" *ngIf="bodyTemplate" [ngClass]="params.contentClass">
                <ng-container *ngTemplateOutlet="bodyTemplate; context: params.data"></ng-container>
            </div>
            <div class="modal-footer" *ngIf="params.validateButton?.displayed || params.closeButton?.displayed">
                <button data-dismiss="modal"
                        class="btn btn-lg pull-left"
                        [ngClass]="'btn-' + params.closeButton.type"
                        [ngStyle]="params.closeButton.style"
                        type="button"
                        (click)="close(params.closeButton.action)"
                        *ngIf="params.closeButton && params.closeButton.displayed"
                        [disabled]="disabled">
                    <i [ngClass]="params.closeButton.icon" *ngIf="params.closeButton.icon"></i>
                    <span [ngClass]= "{ 'with-icon' : params.closeButton.icon}"
                          *ngIf="!params.closeButton.textKey">
                        {{params.closeButton.text}}</span>
                    <span [ngClass]= "{ 'with-icon' : params.closeButton.icon}"
                          *ngIf="params.closeButton.textKey"
                          [i18n]="params.closeButton.textKey"></span>
                </button>

                <button data-dismiss="modal"
                        class="btn btn-lg pull-right"
                        [ngClass]="'btn-' + params.validateButton.type"
                        [ngStyle]="params.validateButton.style"
                        type="button"
                        (click)="resolve(params.validateButton.action)"
                        *ngIf="params.validateButton && params.validateButton.displayed"
                        [disabled]="disabled || (params.validateButton.disabled && params.validateButton.disabled())">
                    <i [ngClass]="params.validateButton.icon" *ngIf="params.validateButton.icon"></i>
                    <span [ngClass]= "{ 'with-icon' : params.validateButton.icon}"
                          *ngIf="!params.validateButton.textKey">
                        {{params.validateButton.text}}</span>
                    <span [ngClass]= "{ 'with-icon' : params.validateButton.icon}"
                          *ngIf="params.validateButton.textKey"
                          [i18n]="params.validateButton.textKey"></span>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop fade in" *ngIf="opened"></div>
